import { jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable import/no-cycle */
/* eslint-disable react/require-default-props */
import { useCallback, useContext, useState } from "react";
import { apiGetProductInfo } from "Root/api/apiCheckout";
import { GainfulButton } from "CheckoutComponents";
import x from "Images/checkout/x.svg";
import styles from "./styles.module.css";
import { useDispatch } from "react-redux";
import LoadCurrentProductThunk from "Root/profile/redux/thunkCreators/products/currentProduct";
import CheckoutResultsProductDetailsDrawer from "../CheckoutResultsNew/CheckoutResultsProduct/CheckoutResultsProductDetailsDrawer";
import FormToggle from "Root/profile/components/common/FormToggle";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { CheckoutContext } from "Root/checkout/CheckoutRoutes";
const ProductCard = ({ image, category, title, type, description, label, isRow, isCentered, regularPrice, netPrice, servings, addToCart, removeFromCart, cartItem, ingredientInfo = {
    ingredients: [],
    nutrition_facts: "",
    product_title: "",
    product_key: "",
    name: "",
    macros: [],
    key_benefits: [],
}, }) => {
    const { sellingPlan, setSellingPlan, sellingPlanOptions } = useContext(CheckoutContext);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [productData, setProductData] = useState(null);
    const dispatch = useDispatch();
    const [expanded, setExpanded] = useState({
        nutrition: false,
        ingredients: false,
        benefits: false,
        how_to_use: false,
        amino_acid: false,
    });
    const onChangeSellingPlan = (value) => {
        const plan = sellingPlanOptions[type].find((item) => item.external_plan_id === value);
        if (plan) {
            localStorage.setItem("selling_plan", JSON.stringify({
                ...sellingPlan,
                [type]: plan,
            }));
            setSellingPlan({
                ...sellingPlan,
                [type]: plan,
            });
        }
    };
    const fetchProductData = (product) => {
        const getProductInfo = async (key) => {
            const data = (await apiGetProductInfo(key));
            if (data) {
                setProductData(data);
            }
        };
        getProductInfo(product);
    };
    const removeProductFromCart = useCallback(() => {
        removeFromCart && removeFromCart(type);
    }, [removeFromCart, type]);
    const addProductToCart = useCallback(() => {
        const item = category === "hydration" || category === "preworkout" ? category : type;
        if (type === "boost") {
            addToCart && addToCart(title.toLowerCase());
        }
        else {
            addToCart && addToCart(item);
        }
    }, [addToCart, category, type, title]);
    const isGreens = title.toLowerCase().includes("greens");
    const openDrawer = (product) => {
        if (product === "blenderbottle" ||
            product === "waterbottle" ||
            product === "wb221" ||
            product === "wb222" ||
            product === "other" ||
            product === "frother")
            return;
        // only fetch product data if it wasn't fetched before
        const params = product === "boost" ? title.toLocaleLowerCase() : product;
        if (!productData) {
            fetchProductData(params);
        }
        setIsDrawerOpen(true);
    };
    const onToggle = (value) => {
        const find3WeekPlan = (item) => {
            const plans = sellingPlanOptions[item];
            if (plans) {
                return plans.find((plan) => plan.subscription_preferences.charge_interval_frequency === 4);
            }
        };
        setSellingPlan({
            ...sellingPlan,
            [type]: !value ? { external_plan_id: "otb" } : find3WeekPlan(type),
        });
        localStorage.setItem("selling_plan", JSON.stringify({
            ...sellingPlan,
            [type]: !value ? { external_plan_id: "otb" } : find3WeekPlan(type),
        }));
    };
    const toggleDrawer = (value) => () => {
        if ([
            "blenderbottle",
            "waterbottle",
            "wb221",
            "wb222",
            "other",
            "frother",
        ].includes(cartItem?.item_key))
            return;
        setIsDrawerOpen(value);
        if (value && cartItem?.item_type) {
            dispatch(LoadCurrentProductThunk(type === "boost" ? cartItem.short_name.toLowerCase() : cartItem?.item_type));
        }
    };
    const discountPercentAmountFromPlan = sellingPlanOptions[type]?.find((item) => {
        return item.subscription_preferences.charge_interval_frequency === 3;
    })?.discount_amount;
    const discountedPrice = Number(netPrice.replace("$", ""));
    const discountPercentAmount = discountPercentAmountFromPlan || 0;
    const defaultPrice = discountedPrice + discountedPrice * (Number(discountPercentAmount) / 100);
    const isOtb = sellingPlan[type]?.external_plan_id === "otb";
    const price = !isOtb && Math.round(discountedPrice) !== Math.round(defaultPrice) ? (_jsxs(_Fragment, { children: [_jsxs("span", { className: `${styles.netPrice} ${styles.price}`, children: ["$", Math.round(discountedPrice).toFixed(2)] }), "\u00A0", _jsxs("span", { className: `${styles.regularPrice} ${styles.price}`, children: ["$", Math.round(defaultPrice).toFixed(2)] })] })) : (_jsxs("span", { className: `${styles.price}`, children: ["$", Math.round(defaultPrice).toFixed(2)] }));
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: `${styles.card} ${isRow ? styles.cardrow : ""} ${isCentered ? styles.cardcentered : ""}`, children: [_jsx("div", { className: styles.imgwrapper, onClick: toggleDrawer(true), onKeyPress: toggleDrawer(true), role: "button", tabIndex: 0, children: _jsx("img", { src: image, alt: title, className: styles.img }) }), _jsxs("div", { className: `flex flex-col gap-1 ${[
                            "blenderbottle",
                            "waterbottle",
                            "wb221",
                            "wb222",
                            "other",
                        ].includes(type)
                            ? "justify-center"
                            : ""}`, children: [_jsx("div", { className: "type-body-h3-light font-normal", onClick: toggleDrawer(true), role: "button", tabIndex: 0, children: title }), _jsxs("div", { className: "type-body", children: [description || (_jsxs(_Fragment, { children: [!!servings && (_jsxs(_Fragment, { children: [servings, " ", _jsx("span", { className: styles.pipe, children: "|" }), "\u00A0"] })), price] })), addToCart && _jsx("div", { className: styles.price, children: price })] }), label && label?.length > 0 && (_jsx("div", { className: `${styles.label}`, children: label })), isRow &&
                                ![
                                    "blenderbottle",
                                    "waterbottle",
                                    "wb221",
                                    "wb222",
                                    "other",
                                    "frother",
                                ].includes(type) && (_jsxs("div", { className: "flex flex-col gap-1 pt-2", children: [_jsx(FormToggle, { id: type, toggledText: "Subscribe & Save", untoggledText: "Subscribe & Save", name: "plan", checked: sellingPlan[type] &&
                                            sellingPlan[type]?.external_plan_id &&
                                            sellingPlan[type]?.external_plan_id !== "otb", onChange: onToggle, subLabel: "", className: `${styles.autoAlign} !border-none !p-0 !justify-start gap-1 !mb-0 max-w-[200px] !min-w-0` }), sellingPlan[type]?.external_plan_id !== "otb" &&
                                        sellingPlan[type]?.external_plan_id && (_jsxs(_Fragment, { children: [_jsx(FormControl, { className: "w-full", children: _jsx(Select, { labelId: "ship-label", id: "ship-select", value: sellingPlan[type]?.external_plan_id, onChange: (e) => {
                                                        onChangeSellingPlan(e.target.value);
                                                    }, className: "bg-white", children: sellingPlanOptions[type].map((item) => (_jsx(MenuItem, { value: item.external_plan_id, children: item.title }, item.external_plan_id))) }) }), _jsxs("div", { className: "flex flex-col", children: [_jsxs("div", { className: "flex gap-1 items-center", children: [_jsx("span", { className: "w-5 h-5", children: _jsxs("svg", { width: "40", height: "40", viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("circle", { cx: "10", cy: "10.3", r: "7.5", fill: "#60D179" }), _jsx("path", { d: "M7 10.3L9 12.3L13 8.30005", stroke: "#333333" })] }) }), _jsx("span", { children: "Save on every order" })] }), _jsxs("div", { className: "flex gap-1 items-center", children: [_jsx("span", { className: "w-5 h-5", children: _jsxs("svg", { width: "40", height: "40", viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("circle", { cx: "10", cy: "10.3", r: "7.5", fill: "#60D179" }), _jsx("path", { d: "M7 10.3L9 12.3L13 8.30005", stroke: "#333333" })] }) }), _jsx("span", { children: "Skip/cancel anytime" })] })] })] }))] })), addToCart && (_jsx(GainfulButton, { text: "Add", onClick: addProductToCart, size: "w100", style: ["blenderbottle", "waterbottle", "wb221", "wb222"].includes(type)
                                    ? { marginTop: "auto" }
                                    : {} })), removeFromCart && !["other"].includes(type) && (_jsx("button", { type: "button", className: styles.remove, onClick: removeProductFromCart, "aria-label": "Remove from cart", children: _jsx("img", { alt: "remove", src: x }) }))] })] }), _jsx(CheckoutResultsProductDetailsDrawer, { openDrawer: isDrawerOpen, toggleDrawer: toggleDrawer, product: cartItem, ingredientInfo: ingredientInfo, expanded: expanded, setExpanded: (value) => setExpanded(value) })] }));
};
export default ProductCard;
